import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '../../shared/services';

@Component({
  selector: 'app-homepage-nudge',
  templateUrl: './homepage-nudge.component.html',
  styleUrls: ['./homepage-nudge.component.scss']
})
export class HomepageNudgeComponent implements OnInit {

  @Input() fundraiser;
  isMobile;

  constructor(
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util?.isMobile();
  }

  redirect(type) {
    if (type?.target?.className?.match('know')) {
      this.util.router.navigate(['/new/sip'], { queryParams: {utm_source: 'internal_ketto', utm_content: 'banner_knowmore', pos: 'referral-bg-image'}, queryParamsHandling: 'merge'}).then(() => {
        this.util.setUtm();
      });
    } else {
      this.util.router.navigate(['/new/sip'], { queryParams: {utm_source: 'internal_ketto', utm_content: 'banner_donate'}, queryParamsHandling: 'merge'}).then(() => {
        this.util.setUtm;
      });
      setTimeout(() => {
        this.util.scrollToTop();
      }, 500);
    }

  }

}
